import { gql } from '@apollo/client';
import { FLYER_FRAGMENT } from './FlyerFragment.graphql';

export const GET_UPCOMING_FLYERS = gql`
  query getUpcomingFlyers($input: GetFlyersInput!) {
    getUpcomingFlyers(input: $input) {
      items {
        ...FlyerDetails
      }
      pagination {
        pageSize
        pageNumber
        total
      }
    }
  }
  ${FLYER_FRAGMENT}
`;
